module.exports = __webpack_public_path__ + "img/change_line.43830dfa.png";